/**
 * Customer-facing support conduct summary (parity with server supportConduct.constants).
 * Keep wording aligned when updating either side.
 */
export const SUPPORT_CONDUCT_CUSTOMER_SUMMARY =
  "Ask anything about an order, delivery, or your account.";

export const SUPPORT_TALK_TO_TEAMMATE_MESSAGE = 'I would like to speak with a representative';

export const SUPPORT_HUMAN_REQUEST_PHRASES = [
  'agent',
  'human',
  'real person',
  'live person',
  'live agent',
  'representative',
  'talk to someone',
  'talk to a person',
  'talk to a human',
  'speak to someone',
  'speak to a person',
  'customer service',
  'customer support',
  'teammate',
  'real human',
  'actual person'
] as const;

export const isSupportHumanRequest = (text: string): boolean => {
  const normalized = String(text || '')
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!normalized) return false;
  return SUPPORT_HUMAN_REQUEST_PHRASES.some((phrase) => normalized.includes(phrase));
};

